/*
  Registro central dos area codes de permissão.

  Não havia nenhum: cada tela escrevia a string à mão e o `AuthService.hasPermission` nega
  em silêncio o que não encontra, então um typo não quebra nada visível — só esconde a tela
  de quem deveria vê-la. Foi assim que `business_config.catalogs` (plural) passou
  despercebido aqui e no app do salão.

  A lista abaixo é a tabela `permissions` da API, conferida em produção. `areaCodes.test.js`
  compara o que o código usa contra ela e reprova o que não estiver aqui.
*/
export const AREA_CODES = Object.freeze([
  'agenda',
  'agenda.all',
  'agenda.personal',
  'bills',
  'bills.items_amount',
  'bills.items_comission',
  'bills.items_value',
  'business_config',
  'business_config.agenda',
  'business_config.bank_accounts',
  'business_config.bundles',
  'business_config.catalog',
  'business_config.loyalty_cards',
  'business_config.personal_data',
  'business_config.products',
  'business_config.professionals',
  'business_config.services',
  'customers',
  'dashboard',
  'financial',
  'financial.business_earnings',
  'financial.cash_register_history',
  'financial.cash_registers',
  'financial.closed_bills',
  'financial.comissions',
  'financial.dre',
  'financial.open_bills',
  'financial.total_earnings',
  'schedule_history'
])

/*
  Usados pelo site e **não** cadastrados na API. Escondem a tela de todo profissional que
  não seja `administrador`, porque o `hasPermission` nega o que não encontra.

  - `banking.transfers` — o Cutilei Pay não foi lançado e as permissões dele não foram
    semeadas. **Quando for lançado, cadastrar antes**, ou a área nasce invisível para todo
    profissional. O app do salão tem a mesma pendência, mais o `banking` do menu.
  - `banking.payouts` — os recebíveis do repasse automático da Cutilei. Mesma pendência e
    mesmo seeder (`BankingPermissionsSeeder`, que cadastra os cinco codes de uma vez), com o
    detalhe de que aqui o dinheiro é da profissional: sem o code cadastrado, quem atende pela
    Cutilei não encontra a tela onde vê o que ainda vai receber.
  - `business_config.card_machines` — aba Maquininhas das Configurações. Cadastrada pelo
    `CardMachinesPermissionSeeder` da API, que **precisa rodar antes do deploy do site**: sem
    o code, a aba some para todo profissional que não seja `administrador`. Depois de rodar
    em produção, mover para `AREA_CODES`.
  - `financial.cash_flow` — aba Fluxo de caixa do Financeiro. Ainda não existe na API: cadastrar
    antes do deploy, ou a aba some para todo profissional que não seja `administrador`.
  - `whatsapp` — Gestão WhatsApp. Com ela, a profissional vê e responde as conversas do número
    do salão (só a aba Conversas; conectar e o jeito de atender ficam com o dono). Cadastrada
    pelo `WhatsappPermissionsSeeder` da API, que precisa rodar antes do deploy do site; sem o
    code, o dono não tem o que liberar. Depois de rodar em produção, mover para `AREA_CODES`.
*/
export const UNREGISTERED_AREA_CODES = Object.freeze([
  'banking.transfers',
  'banking.payouts',
  'business_config.card_machines',
  'financial.cash_flow',
  'whatsapp'
])

/*
  Áreas em que só "Visualizar" faz sentido: editar e excluir não mudam nada nelas, então as telas
  de permissão não mostram essas duas opções. No WhatsApp, ver a área já é conectar o número dela
  e atender as conversas do salão.
*/
export const VIEW_ONLY_AREA_CODES = Object.freeze(['whatsapp'])

export const isViewOnlyArea = areaCode => VIEW_ONLY_AREA_CODES.includes(areaCode)
